import React, { useState } from 'react';



const Technologies = () => {
  const [activeTab, setActiveTab] = useState('iot');

  const techData = {
   iot: [
  { 
    name: 'Lean Manufacturing & Kaizen Consulting', 
    image: '/images/projects/Lean-m.png', 
    
   
  },
  { 
    name: 'OEE & Production Efficiency Improvement', 
    image: '/images/projects/OEE-P.png', 
   
  },
  { 
    name: 'Digital SOP & Production Documentation Industrial Waste Reduction (Muda Elimination) ', 
    image: '/images/projects/Digital-S.png', 
     
  },
  { 
    name: 'Cycle Time Optimization', 
    image: '/images/projects/Cycle-t.png', 
    
  },
  { 
    name: 'Shop Floor Visualization & Andon Systems', 
    image: '/images/projects/Shop-f.png', 
   
  }
  
]
,
    aiml: [
      { 
    name: 'Industrial IoT (IIoT) & Machine Connectivity', 
    image: 'https://images.pexels.com/photos/1181676/pexels-photo-1181676.jpeg', 
    
  },
  { 
    name: 'Real-Time Production Monitoring Dashboards', 
    image: '/images/projects/rt.png', 
   
  },
  { 
    name: 'Predictive Maintenance Solutions', 
    image: '/images/projects/Pre.png', 
   
  },
  { 
    name: 'Industrial Data Gateways & Protocol Conversion', 
    image: '/images/projects/ind.png', 
   
  },
  { 
    name: 'Smart Factory Energy Monitoring', 
    image: '/images/projects/Smart.png', 
    
  },
  { 
    name: 'Remote Asset Tracking & Telemetry', 
    image: '/images/projects/Remote.png', 
    
  },
  
],
    deeplearning: [
      { 
   name: 'Manufacturing Execution Systems ', 
    image: '/images/projects/mes.png', 
      
  },
  { 
    name: 'End-to-End Product Traceability Systems', 
    image: '/images/projects/End-to.png', 
    
  },
  { 
    name: 'Statistical Process Control Tools', 
    image: '/images/projects/Statical-p.png', 
    
  },
  { 
    name: 'Smart Visitor Management Systems ', 
    image: '/images/projects/vsm.png', 
    
  },
  { 
    name: 'Industrial Quality Management Software ', 
    image: '/images/projects/qms.png', 
   
  },
  { 
    name: 'ERP & Shop Floor Data Integration', 
    image: '/images/projects/ERP.png', 
    
  }
],
    arvr: [
     
 
  { 
    name: 'Custom SPM (Special Purpose Machine) Design', 
    image: '/images/projects/spm.png', 
    
  },
  { 
    name: 'Automated Assembly & Conveyor Systems', 
    image: '/images/projects/cnv.png', 
   
  },
  {
  name: 'Control Panel Design & Retrofitting', 
    image: '/images/projects/cnt.png', 
  
  },
  { 
    name: 'Servo Motion Control & Drives', 
    image: '/images/projects/Servo.png', 
    
  },
  
],
    ai: [
    
  { 
    name: 'Smart decision-making', 
    image: '/images/projects/desicison_making.png' , 
 
    
  },
  
  { 
    name: 'Real-time data insights', 
    image: '/images/projects/real_in.png', 
  
  },
  { 
    name: 'Anomaly Detection', 
    image: '/images/projects/anomoly.png', 
    
  },
  { 
    name: 'Vision Based Solutions', 
    image: '/images/projects/vision.png', 
    
  }
]
    
  };

  const tabs = [
    { id: 'iot', label: 'OT Solutions'},
    { id: 'aiml', label: 'IOT'},
    { id: 'deeplearning', label: 'IT' },
    { id: 'arvr', label: 'Automation' },
    { id: 'ai', label: 'AI & ML' }
    // { id: 'ar', label: 'AR & VR' }
  ];

  return (
    <section className="section text-center" style={{background: 'linear-gradient(135deg, #f5f7fa 0%, #FFFFFF 100%)'}}>
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto text-center">
            <h2 className="font-weight-600 mb-3">Technologies we work with</h2>
            <hr className="heading-separator-line border-primary border-2 d-block mx-auto" />
            <p className="text-4 mb-5">Explore the cutting-edge technologies and platforms we leverage to deliver innovative IoT, automation, AI, and immersive solutions.</p>
          </div>
        </div>
        
        {/* Modern Tab Buttons */}
        <div className="mb-5">
          <div className="d-flex flex-wrap justify-content-center gap-3" style={{gap: '15px'}}>
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`btn ${activeTab === tab.id ? 'btn-primary' : 'btn-outline-primary'}`}
                style={{
                  borderRadius: '25px',
                  padding: '12px 30px',
                  fontSize: '17px',
                  fontWeight: '500',
                  transition: 'all 0.3s ease',
                  transform: activeTab === tab.id ? 'scale(1.05)' : 'scale(1)',
                  boxShadow: activeTab === tab.id ? '0 5px 15px rgba(0,0,0,0.2)' : 'none',
                  margin: '5px'
                }}
              >
                <span style={{marginRight: '8px'}}>{tab.icon}</span>
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Tech Items with Animation */}
        <div className="row text-center justify-content-center">
          {techData[activeTab].map((tech, index) => (
            <div 
              key={index} 
              className="col-6 col-sm-6 col-md-4 col-lg-4 mb-4"
              style={{
                animation: 'fadeInUp 0.5s ease-out',
                animationDelay: `${index * 0.1}s`,
                animationFillMode: 'both'
              }}
            >
              <div 
                style={{
                  position: 'relative',
                  transition: 'transform 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-10px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
              >
                <div style={{
  position: 'relative',
  borderRadius: '15px',
  overflow: 'hidden',
  boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
  marginBottom: '15px'
}}>
  {/* IMAGE */}
  <img 
    src={tech.image} 
    alt={tech.name} 
    style={{
      width: '100%',
      height: '180px',
      objectFit: 'cover',
      display: 'block'
    }} 
  />

  {/* DARK GRADIENT OVERLAY */}
  <div style={{
    position: 'absolute',
    inset: 0,  // top:0, right:0, bottom:0, left:0
    background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.55) 50%, rgba(0,0,0,0.2) 100%)'
  }} />

  {/* TEXT */}
  <div style={{
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: 'clamp(8px, 2vw, 14px)',
    color: 'white',
    fontWeight: '700',
    fontSize: 'clamp(12px, 2.4vw, 17px)',
    lineHeight: '1.3',
    zIndex: 2
  }}>
    {tech.name}
  </div>
</div>

              </div>
            </div>
          ))}
        </div>
        
      </div>

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default Technologies;
